import { IRuleMySuffix } from 'src/app/shared/model//rule-my-suffix.model';
import { ICountryMySuffix } from './country-my-suffix.model';

export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}

export interface ICargoGroupMySuffix {
    id?: number;
    name?: string;
    taricCode?: string;
    description?: string;
    activeStatus?: ActiveStatus;
    rules?: IRuleMySuffix[];
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    fromEffectiveDate?: string;
    hsCode?: number;
    cargoCountry?: ICountryMySuffix;
}

export class CargoGroupMySuffix implements ICargoGroupMySuffix {
    constructor(
        public id?: number,
        public name?: string,
        public taricCode?: string,
        public description?: string,
        public activeStatus?: ActiveStatus,
        public rules?: IRuleMySuffix[],
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public fromEffectiveDate?: string,
        public hsCode?:number,
        public cargoCountry?: ICountryMySuffix
    ) {
        this.activeStatus = ActiveStatus.ACTIVE;
    }
}
